import { ChangeDetectorRef, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AgGridStateService } from '../../Service/ag-grid-state.service';
import { ApiService } from '../../Service/api.service';
import { CommonStandaloneImports } from '../common/common-standalone-imports';
import { environment } from '../../../environments/environment';
import { filter } from 'rxjs';
import { CommonService } from '../../Service/common.service';
import { CallSocketService } from '../../Service/call-socket.service';

@Component({
  standalone: true,
  selector: 'app-sidebar',
  imports: [...CommonStandaloneImports],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  showLogoutModal = false;
  showPopup = false;
  adminName = 'Admin Name';
  contactNumbers: any = ['+91-9876543210', '+91-9123456789'];
  adminEmail = 'admin@example.com';
  userProfile: any;

  constructor(
    private router: Router,
    private sppiner: NgxSpinnerService,
    public commonService: CommonService,
    private toastr: ToastrService,
    private cdRef: ChangeDetectorRef,
    private apiService: ApiService,
    private socketService: CallSocketService
  ) {}

  ngOnInit(): void {
    this.apiService.profileUpdated$.subscribe(() => {
      this.reloadSidebarData();
    });

    this.reloadSidebarData();

    const url = this.commonService.currentRoute;
    if (
      url.includes('doctor-dashboard') ||
      url.includes('detail-dashboard') ||
      url.includes('medical-records')
    ) {
      this.commonService.activeTab = 'dashboard';
    } else if (url.endsWith('/notes')) {
      this.commonService.activeTab = 'notes';
    } else if (url.includes('missed-request')) {
      this.commonService.activeTab = 'missed';
    } else if (url.includes('incomplete-request')) {
      this.commonService.activeTab = 'incomplete';
    } else if (url.includes('user-profile')) {
      this.commonService.activeTab = 'user-profile';
    } else if (url.includes('support')) {
      this.commonService.activeTab = 'support';
    }
  }

  setActiveTab(tab: string): void {
    this.commonService.activeTab = tab;
    switch (tab) {
      case 'dashboard':
        this.router.navigate(['/Dashboard/doctor-dashboard']);
        break;
      case 'notes':
        this.router.navigate(['/notes']);
        break;
      case 'missed':
        this.router.navigate(['/missed-request']);
        break;
      case 'incomplete':
        this.router.navigate(['/incomplete-request']);
        break;
      case 'consult-notes':
        this.router.navigate(['/consult-notes']);
        break;
      case 'user-profile':
        this.router.navigate(['/user-profile']);
        break;
      case 'support':
        this.showPopup = true;
        break;
      case 'logout':
        this.showLogoutModal = true;
        this.cdRef.detectChanges();
        break;
    }
  }

  confirmLogout() {
    this.sppiner.show();
    this.apiService.logoutPatient().subscribe({
      next: (res) => {
        sessionStorage.clear();
        localStorage.clear();
        this.socketService.disconnectSession();
        this.cancelLogout();
        this.router.navigate(['/Login/doctorLogin']);
        this.toastr.success('Logout Successfully');
        this.sppiner.hide();
      },
      error: (err) => {
        if (err.status == 401) {
          this.toastr.error('Your session is already expired.');
          sessionStorage.clear();
          localStorage.clear();
          this.sppiner.hide();
          this.router.navigate(['/Login/doctorLogin']);
          return;
        }
        this.sppiner.hide();
        this.toastr.error(
          'Logout failed: ' + (err.error?.message || 'Server error')
        );
      },
    });
  }

  cancelLogout() {
    this.showLogoutModal = false;
    this.cdRef.detectChanges();
  }

  togglePopup() {
    this.showPopup = !this.showPopup;
  }

  closePopup() {
    this.showPopup = false;
    const url = this.router.url;
    if (url.includes('doctor-dashboard') || url.includes('detail-dashboard')) {
      this.commonService.activeTab = 'dashboard';
    } else if (url.includes('note')) {
      this.commonService.activeTab = 'note';
    } else if (url.includes('support')) {
      this.commonService.activeTab = 'support';
    } else {
      this.commonService.activeTab = '';
    }
  }

  reloadSidebarData() {
    this.userProfile = JSON.parse(
      localStorage.getItem('doctorProfile') || '{}'
    );

    if (this.userProfile?.profile) {
      let profilePath = this.userProfile.profile;

      if (profilePath.startsWith('/uploads')) {
        profilePath = environment.baseUrl + profilePath;
      }

      this.userProfile.profile = profilePath.replace('uploads/images/', '');
    }

    this.cdRef.detectChanges();
  }

  checkCallRinging() {
    const rawDetails = JSON.parse(
      localStorage.getItem('ivrPatientCallDetails') || '{}'
    );

    if (rawDetails && rawDetails?.raw) {
      return 'disabled-logout';
    }
    return '';
  }
}
